import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="domtokenlist" id="domtokenlist"></a>
    <h1 {...{
      "id": "windowdomtokenlist"
    }}>{`window.DOMTokenList`}</h1>
    <p>{`DOMTokenList supports the ClassList and other token list functionality`}</p>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://dom.spec.whatwg.org/#interface-domtokenlist"
        }}>{`https://dom.spec.whatwg.org/#interface-domtokenlist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/DOMTokenList"
        }}>{`https://developer.mozilla.org/en-US/docs/Web/API/DOMTokenList`}</a></li>
    </ul>
    <a name="domtokenlist-length" id="domtokenlist-length"></a>
    <h2 {...{
      "id": "length"
    }}>{`length`}</h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns the number of tokens in the list`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-length"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-length`}</a>{`  `}</p>
    <a name="domtokenlist-value" id="domtokenlist-value"></a>
    <h2 {...{
      "id": "value"
    }}>{`value`}</h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The serialized string value of the token list`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-value"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-value`}</a>{`  `}</p>
    <a name="domtokenlist-add" id="domtokenlist-add"></a>
    <h2 {...{
      "id": "addtokens"
    }}>{`add(...tokens)`}</h2>
    <p>{`Adds the specified tokens to the token list. If the token is already present, no error is thrown.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-add"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-add`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...tokens`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-remove" id="domtokenlist-remove"></a>
    <h2 {...{
      "id": "removetokens"
    }}>{`remove(...tokens)`}</h2>
    <p>{`Removes the specified items from the token list. If the token is not present, no error is thrown.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-remove"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-remove`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...tokens`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-replace" id="domtokenlist-replace"></a>
    <h2 {...{
      "id": "replaceoldtoken-newtoken"
    }}>{`replace(oldToken, newToken)`}</h2>
    <p>{`Replaces an old token with a new token. If the old token doesn't exist,
no action occurs, and `}<inlineCode parentName="p">{`false`}</inlineCode>{` is returned.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-replace"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-replace`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldToken`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newToken`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-toggle" id="domtokenlist-toggle"></a>
    <h2 {...{
      "id": "toggletoken-force"
    }}>{`toggle(token, force)`}</h2>
    <p>{`Toggles a token within the list. If `}<inlineCode parentName="p">{`force`}</inlineCode>{` is not present, then the following
rules are applied:`}</p>
    <ul>
      <li parentName="ul">{`if the token is present, it is removed, and `}<inlineCode parentName="li">{`false`}</inlineCode>{` is returned`}</li>
      <li parentName="ul">{`if the token isn't present, it is added, and `}<inlineCode parentName="li">{`true`}</inlineCode>{` is returned`}</li>
    </ul>
    <p>{`If `}<inlineCode parentName="p">{`force`}</inlineCode>{` is supplied, then:`}</p>
    <ul>
      <li parentName="ul">{`if `}<inlineCode parentName="li">{`true`}</inlineCode>{`, the token is added`}</li>
      <li parentName="ul">{`if `}<inlineCode parentName="li">{`false`}</inlineCode>{`, the token is removed`}</li>
    </ul>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - if the token exists in the last after the operation`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-toggle"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-toggle`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`force`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-item" id="domtokenlist-item"></a>
    <h2 {...{
      "id": "itemindex"
    }}>{`item(index)`}</h2>
    <p>{`Return the item at the specified index, or `}<inlineCode parentName="p">{`null`}</inlineCode>{` if the index is out-of-range`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the item at the index, or null if index is out of range`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-item"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-item`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-contains" id="domtokenlist-contains"></a>
    <h2 {...{
      "id": "containstoken"
    }}>{`contains(token)`}</h2>
    <p>{`Returns whether the token is in the list or not.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - if `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the token is in the list, otherwise it isn't`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-contains"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-contains`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="domtokenlist-supports" id="domtokenlist-supports"></a>
    <h2 {...{
      "id": "supportstoken"
    }}>{`supports(token)`}</h2>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` if the token is acceptable to the list; otherwise returns `}<inlineCode parentName="p">{`false`}</inlineCode>{`.
If `}<inlineCode parentName="p">{`false`}</inlineCode>{` is returned, passing the token would throw an error when calling
any other method.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - if `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the token is acceptable when calling other methods`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-domtokenlist-supports"
      }}>{`https://dom.spec.whatwg.org/#dom-domtokenlist-supports`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      